import React, { useState, useCallback, useMemo, useEffect, useContext } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Button, Navbar } from 'react-bootstrap';
import { NavLink, useLocation, useNavigate, Outlet } from 'react-router-dom';
import {
  BiSolidDashboard, BiTimeFive, BiChip, BiBarChartAlt2,
  BiBarChart, BiPulse, BiSolidExtension,
  BiDetail
} from "react-icons/bi";
import { AiOutlineStock } from "react-icons/ai";
import { FiActivity } from 'react-icons/fi';
import {
  MdPowerSettingsNew, MdInsertInvitation, MdMarkunreadMailbox, MdAccountCircle,
  MdList, MdManageAccounts, MdPrecisionManufacturing, MdAssignmentTurnedIn, MdAssessment, MdTrendingUp, MdMoreVert, MdLock,
  MdLanguage, MdLightMode, MdDarkMode,
  MdDashboard, MdSchedule, MdGroups, MdMap, MdReportProblem, MdLoop,
  MdEditNote, MdCampaign, MdAssignmentInd, MdEventNote, MdAssignment
} from "react-icons/md";
import { AiTwotoneProfile } from "react-icons/ai";
import { FaChartBar, FaCogs, FaTools, FaWrench } from 'react-icons/fa';
import { Tooltip, Menu, MenuItem, IconButton } from '@mui/material';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import logo from '../../assets/yantraimage.png';
import Swal from 'sweetalert2';
import useMobileWidth from './smalldevicesidebar';
import './sidebars.css';
import { SlArrowDown } from "react-icons/sl";
import { GoChevronDown, GoChevronUp } from "react-icons/go";
import { IoSettingsOutline } from "react-icons/io5";
import { IoMdSettings } from "react-icons/io";
import { FaChartLine } from "react-icons/fa";
import { stopTokenAutoRefresh } from '../Services/app/loginservice';
import { UserDetailsContext } from '../Shared/context/UserDetailsContext';
import { TbChecklist, TbFolders, TbLayoutGrid, TbSettings, TbReportAnalytics } from "react-icons/tb";
import ChangePasswordCard from '../Nav/changepassword';
import NotificationBell from '../Pages/NotificationBell/notificationBell';
import { RiNotificationBadgeLine } from "react-icons/ri";
import { FiCheckSquare } from "react-icons/fi";
import { BsGraphUp, BsJustify } from "react-icons/bs";
import { BsKanban, BsList } from "react-icons/bs";
import { MdVerifiedUser, MdRule } from "react-icons/md";
import { cleanCustomerId } from '../Services/app/operatorservice';
import { BsCalendarCheckFill } from "react-icons/bs";


const handleConfigurationClick = () => {
  window.open(`${window._env_.SERVER_URL}home`, "_blank");
};

export default function PersistentDrawerLeft({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const [masterOpen, setMasterOpen] = useState(false);
  const [dashboardOpen, setDashboardOpen] = useState(false);
  const [operationOpen, setOperationOpen] = useState(false);
  const [analyticsOpen, setAnalyticsOpen] = useState(false);
  const [productionOpen, setProductionOpen] = useState(false);
  const [maintenanceOpen, setMaintenanceOpen] = useState(false);
  const [qualityOpen, setQualityOpen] = useState(false);
  const [reportsOpen, setReportsOpen] = useState(false);
  const [leaderboardOpen, setLeaderboardOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [showChangePassword, setShowChangePassword] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const isCssFallback = React.useRef(false);

  // Language + theme (persisted to localStorage). Theme actually flips CSS
  // variables on <body data-theme="dark">. Language picker is UI-only for now —
  // full i18n strings ship in a later phase.
  const [lang, setLang] = useState(() => localStorage.getItem('yantra_lang') || 'en');
  const [theme, setTheme] = useState(() => localStorage.getItem('yantra_theme') || 'light');
  const [langOpen, setLangOpen] = useState(false);
  useEffect(() => {
    localStorage.setItem('yantra_lang', lang);
  }, [lang]);
  useEffect(() => {
    localStorage.setItem('yantra_theme', theme);
    document.body.setAttribute('data-theme', theme);
  }, [theme]);
  const LANG_LABELS = { en: 'EN', hi: 'हि', ta: 'த' };
  const LANG_FULL = { en: 'English', hi: 'हिन्दी', ta: 'தமிழ்' };

  const isMobile = useMobileWidth();
  const navigate = useNavigate();
  const location = useLocation();
  const customerId = localStorage.getItem("CustomerID");
  const userRole = JSON.parse(localStorage.getItem("userDetails"));
  const mode = userRole?.mode;
  const normalizedMode = mode?.toLowerCase().replace(/\s+/g, "");
  const { userDetails } = useContext(UserDetailsContext);
  const [pageList, setPageList] = useState(userDetails.pageList || []);
  const showReportChildren =
    ["quality", "superadmin", "admin"].includes(normalizedMode) &&
    cleanCustomerId(customerId) === window._env_.CUSTOMER_ID;

  const showReportChildren1 =
    ["superadmin", "admin"].includes(normalizedMode) &&
    cleanCustomerId(customerId) === window._env_.GPLAST_CUSTOMER_ID;


  useEffect(() => {
    const parsed = typeof userDetails === 'string' ? JSON.parse(userDetails) : userDetails;
    setPageList(parsed.pageList || []);
  }, [userDetails]);


  let user = null;
  try {
    user = JSON.parse(localStorage.getItem('authority')) || '';
  } catch (e) {
    user = '';
  }

  // Yantra Intelligence pages gating: the user description (TB additionalInfo.description -> userDetails JSON)
  // contains the role. We scan all likely fields (mode/role/userRole/Role/description/title)
  // for a normalized "superadmin" / "admin" match so it works regardless of field name.
  const isAiAdmin = (() => {
    const candidates = [
      userRole?.mode,
      (()=>{try{return JSON.parse(userRole?.description||'{}')?.mode}catch(e){return ''}})(),
      userRole?.role,
      userRole?.userRole,
      userRole?.Role,
      userRole?.description,
      userRole?.title,
      localStorage.getItem('role_name'),
    ];
    const normalize = (s) => String(s || '').toLowerCase().replace(/[\s_-]+/g, '');
    const norm = candidates.map(normalize);
    return user === 'TENANT_ADMIN'
      || user === 'SYS_ADMIN'
      || norm.some(v => v === 'superadmin' || v === 'admin' || v === 'sysadmin' || v === 'tenantadmin');
  })();

  const firstName = JSON.parse(localStorage.getItem('firstName') || 'null');
  const lastName = JSON.parse(localStorage.getItem('lastName') || 'null');
  const username = [firstName, lastName].filter(Boolean).join(' ');

  const toggle = useCallback(() => setIsOpen(prev => !prev), []);

  const handleMenuItemClick = (item) => (e) => {
    if (item.name === "Configuration") {
      e.preventDefault();
      handleConfigurationClick();
      if (isMobile) setIsOpen(false);
    } else if (isMobile) {
      setIsOpen(false);
    } else {
      // toggle();
    }
  };

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  // const menuItem = useMemo(() => [
  //   ...(user === "TENANT_ADMIN" ? [{ path: "/configuration", name: "Configuration", icon: <MdManageAccounts /> }] : []),
  //   {
  //     name: "Dashboard",
  //     icon: <BiSolidDashboard />,
  //     children: [
  //       { path: "/company", name: "Company", icon: <BiBarChartAlt2 /> },
  //       { path: "/machinemm", name: "Machine", icon: <IoMdSettings /> },
  //       { path: "/deviceoee", name: "Oee", icon: <FaChartLine style={{ fontSize: "23px" }} /> },
  //     ]
  //   },
  //   // {
  //   //   name: "Analytics",
  //   //   icon: <BiBarChart />,
  //   //   children: [
  //   //     { path: "/analytics", name: "Analytics 1", icon: <BiBarChart /> },
  //   //   ]
  //   // },
  //   // { path: "/report", name: "Reports", icon: <MdAssessment /> },
  //   {
  //     name: "Operation",
  //     icon: <MdPrecisionManufacturing />,
  //     children: [
  //       { path: "/operator-details", name: "Allocation", icon: <MdAssignmentTurnedIn /> },
  //     ]
  //   },
  // {
  //   name: "Analytics",
  //   icon: <BiChip />,
  //   children: [
  //     { path: "/Alarm", name: "Alarms", icon: <BiChip /> },
  //     { path: "/CurrentShift", name: "Current Shift Details", icon: <BiTimeFive /> },
  //   ]
  // },
  //   {
  //     name: "Master",
  //     icon: <MdList />,
  //     children: [
  //       { path: "/machines", name: "Machine", icon: <MdPrecisionManufacturing /> },
  //       { path: "/shift-registration", name: "Shift", icon: <MdInsertInvitation /> },
  //       { path: "/operator-registration", name: "Operator", icon: <MdAccountCircle /> },
  //       { path: "/user-registration", name: "User", icon: <MdAccountCircle /> },
  //       { path: "/component-registration", name: "Component", icon: <MdMarkunreadMailbox /> },
  //       { path: "/reason-registration", name: "Reason", icon: <MdList /> },
  //     ]
  //   },
  // ], [user]);

  const menuItem = useMemo(() => {
    const baseItems = [
      // ════════════════════════════════════════════════════════════════
      //  1. LIVE — real-time shop-floor view (what's running right now)
      // ════════════════════════════════════════════════════════════════
      {
        name: "Live",
        icon: <BiPulse style={{ fontSize: "20px" }} />,
        children: [
          { path: "/kpi-dashboard",        name: "KPI Dashboard",        icon: <FaChartBar /> },
          { path: "/machinemm",            name: "Machines",             icon: <IoMdSettings /> },
          { path: "/machine-status",       name: "Machine Status",       icon: <BiPulse /> },
          { path: "/deviceoee",            name: "OEE",                  icon: <FaChartLine style={{ fontSize: "23px" }} /> },
          // { path: "/teep", name: "TEEP", icon: <FaChartBar style={{ fontSize: "21px" }} />, bypassPageList: true, alwaysShow: true },
          { path: "/operator-performance", name: "Operator Performance", icon: <BiBarChartAlt2 /> },
          { path: "/operator-leaderboard", name: "Operator Leaderboard", icon: <TbLayoutGrid size={20} /> },
        ],
      },

      // ════════════════════════════════════════════════════════════════
      //  2. PRODUCTION — schedule, work orders, operator allocation
      // ════════════════════════════════════════════════════════════════
      {
        name: "Production",
        icon: <BsKanban style={{ fontSize: "20px" }} />,
        children: [
          { path: "/mes-planning",      name: "MES Cockpit",        icon: <MdDashboard size={20} />, bypassPageList: true },
          { path: "/scheduler",         name: "Scheduler",          icon: <MdSchedule size={20} />, bypassPageList: true },
          // LEGACY: Replaced by /work-orders 2026-06-25 — data migrated to SQL. Page still reachable via URL.
          // { path: "/production-orders", name: "Production Orders",  icon: <AiOutlineStock size={20} />, bypassPageList: true },
          { path: "/labour-board",      name: "Worker Board",      icon: <MdGroups size={20} />, bypassPageList: true },
          { path: "/work-orders",     name: "Work Orders",       icon: <MdAssignment size={20} />, bypassPageList: true },
          { path: "/operation-setup", name: "Operation Setup",   icon: <FaCogs size={18} />, bypassPageList: true },
          { path: "/operator-queue",  name: "Operations Map",    icon: <MdMap size={20} />, bypassPageList: true },
          { path: "/mes-reports",      name: "MES Reports",       icon: <MdAssessment size={20} />, bypassPageList: true },
          { path: "/nc-log",         name: "NC Log",            icon: <MdReportProblem size={20} />, bypassPageList: true },
          { path: "/rework-orders", name: "Rework Orders",     icon: <MdLoop size={20} />, bypassPageList: true },
          { path: "/bom-master",   name: "BOM",                icon: <TbFolders size={20} />, bypassPageList: true },
          { path: "/ecr",          name: "ECR",                icon: <MdEditNote size={20} />, bypassPageList: true },
          { path: "/ecn",          name: "ECN",                icon: <MdCampaign size={20} />, bypassPageList: true },
          ...(cleanCustomerId(customerId) === window._env_.GPLAST_CUSTOMER_ID
            ? [{ path: "/production-overview", name: "Overview", icon: <BsKanban size={20} /> }]
            : []),
          { path: "/operator-details",     name: "Allocation",       icon: <MdAssignmentInd size={20} /> },
          { path: "/production-metrics",   name: "Metrics",          icon: <BsGraphUp size={20} /> },
          { path: "/holiday-list",         name: "Holiday Calendar", icon: <MdEventNote size={20} /> },
        ],
      },

      // ════════════════════════════════════════════════════════════════
      //  3. ENGINEERING — drawings, components, G-code (Paperless Factory)
      // ════════════════════════════════════════════════════════════════
      {
        name: "Engineering",
        icon: <TbFolders style={{ fontSize: "20px" }} />,
        children: [
          { path: "/paperless-factory/drawings", name: "Drawings Library",  icon: <TbLayoutGrid size={20} />,    bypassPageList: true },
          { path: "/paperless-factory/orders",   name: "Drawing Orders",    icon: <TbChecklist size={20} />,     bypassPageList: true },
          { path: "/component-registration",     name: "Components",        icon: <MdMarkunreadMailbox /> },
          { path: "/production-analysis",        name: "Component Analysis", icon: <FaCogs size={18} /> },
          { path: "/analytics",                  name: "Operation Analysis", icon: <TbLayoutGrid size={20} /> },
          { path: "/gcode-optimizer",            name: "G-Code Optimizer",  icon: <TbReportAnalytics size={20} /> },
        ],
      },

      // ════════════════════════════════════════════════════════════════
      //  4. QUALITY & MAINTENANCE — checks, reports, upkeep
      // ════════════════════════════════════════════════════════════════
      {
        name: "Quality & Maintenance",
        icon: <FiCheckSquare size={20} />,
        children: [
          { path: "/inspection/gauging",   name: "Gauging",        icon: <MdRule />,                bypassPageList: true },
          { path: "/inspection/vernier",   name: "Vernier Caliper", icon: <MdRule />,                bypassPageList: true },
          { path: "/inspection/cmm",       name: "CMM",            icon: <MdVerifiedUser />,        bypassPageList: true },
          { path: "/inspection/ct-meter",  name: "CT Meter",       icon: <MdVerifiedUser />,        bypassPageList: true },
          { path: "/inspection/tool-wear", name: "Tool Wear",      icon: <FaCogs />,                bypassPageList: true },
          { path: "/inspection/devices",   name: "Device Settings", icon: <MdManageAccounts />,    bypassPageList: true },
          { path: "/bluecard",              name: "Blue Card Entry",  icon: <MdRule /> },
          { path: "/quality",               name: "Quality Entry",    icon: <MdVerifiedUser /> },
          ...(showReportChildren
            ? [
                { path: "/bluecardreport", name: "Blue Card Report", icon: <MdAssignmentTurnedIn /> },
                { path: "/reports",        name: "Reports",          icon: <MdAssessment /> },
              ]
            : showReportChildren1
              ? [
                  { path: "/reports",   name: "Reports",    icon: <MdAssessment /> },
                  { path: "/erpreport", name: "ERP Report", icon: <BiBarChartAlt2 size={20} /> },
                ]
              : [
                  { path: "/reports",   name: "Reports",    icon: <MdAssessment /> },
                ]),
          { path: "/maintenance-dashboard", name: "Maintenance",    icon: <FaWrench />, bypassPageList: true },
          { path: "/tool-dashboard",        name: "Tool Life",      icon: <FaCogs />,   bypassPageList: true },
        ],
      },

      // ════════════════════════════════════════════════════════════════
      //  5a. NADCAP — aerospace compliance: pyrometry, calibration, certs, audit
      // ════════════════════════════════════════════════════════════════
      {
        name: "NADCAP",
        icon: <MdLock style={{ fontSize: "20px" }} />,
        children: [
          { path: "/nadcap-dashboard", name: "Compliance Cockpit", icon: <MdAssessment size={18} />, bypassPageList: true },
          { path: "/recipe-master", name: "Recipe Master", icon: <FaCogs size={18} />, bypassPageList: true },
          { path: "/route-card-builder", name: "Route Card Builder", icon: <FaCogs size={18} />, bypassPageList: true },
          { path: "/route-card-follower", name: "Route Card Follower", icon: <FaCogs size={18} />, bypassPageList: true },
          { path: "/jigging-panels", name: "Jigging & Test Panels", icon: <FaTools size={18} />, bypassPageList: true },
          { path: "/heat-treat-cycles", name: "Heat Treat Cycles", icon: <FaTools size={18} />, bypassPageList: true },
          { path: "/ndt-inspections", name: "NDT Inspections", icon: <FaTools size={18} />, bypassPageList: true },
          { path: "/anodize-batches", name: "Anodize Batches", icon: <FaTools size={18} />, bypassPageList: true },
          { path: "/calibration-register", name: "Calibration Register", icon: <FaTools size={18} />, bypassPageList: true },
          { path: "/material-certs", name: "Material Certificates", icon: <FaTools size={18} />, bypassPageList: true },
          { path: "/operator-qualifications", name: "Operator Qualifications", icon: <FaTools size={18} />, bypassPageList: true },
          { path: "/audit-trail", name: "Audit Trail", icon: <MdLock size={18} />, bypassPageList: true },
        ],
      },

      // ════════════════════════════════════════════════════════════════
      //  5. BUSINESS — sales, purchase, inventory, CRM, finance, ERP
      // ════════════════════════════════════════════════════════════════
      {
        name: "Business",
        icon: <MdAssessment style={{ fontSize: "20px" }} />,
        children: [
          { path: "/sales",     name: "Sales",     icon: <MdTrendingUp size={20} />,        bypassPageList: true },
          { path: "/purchase",  name: "Purchase",  icon: <MdMarkunreadMailbox size={20} />, bypassPageList: true },
          { path: "/inventory", name: "Inventory", icon: <BsList size={20} />,              bypassPageList: true },
          { path: "/bom",       name: "BOM",       icon: <TbFolders size={20} />,           bypassPageList: true },
          { path: "/mrp",       name: "MRP",       icon: <BiSolidExtension size={20} />,    bypassPageList: true },
          { path: "/finance",   name: "Finance",   icon: <BiBarChart size={20} />,          bypassPageList: true },
          { path: "/crm",       name: "CRM",       icon: <MdAccountCircle size={20} />,     bypassPageList: true },
          { path: "/workforce", name: "Workforce", icon: <MdManageAccounts size={20} />,    bypassPageList: true },
          { path: "/insights",  name: "Insights",  icon: <BsGraphUp size={20} />,           bypassPageList: true },
          { path: "/erpjson",   name: "Legacy ERP", icon: <MdAssessment /> },
        ],
      },

      // ════════════════════════════════════════════════════════════════
      //  6. SETTINGS — masters, admin, notifications
      // ════════════════════════════════════════════════════════════════
      {
        name: "Settings",
        icon: <TbSettings style={{ fontSize: "20px" }} />,
        children: [
          // People
          { path: "/user-registration",   name: "Users",                icon: <MdAccountCircle /> },
          { path: "/group",               name: "Groups",               icon: <TbFolders /> },
          { path: "/shift-registration",  name: "Shifts",               icon: <MdInsertInvitation /> },
          // Foundation
          { path: "/process-master",      name: "Process Master",       icon: <FaCogs />, bypassPageList: true },
          // { path: "/operation-master",   name: "Operation Master",     icon: <FaCogs />, bypassPageList: true },  // hidden — accessed via Process Master drill-down
          // Site setup flow: Site → Floor → Machines → Group → Capability
          { path: "/sites",               name: "Sites",                icon: <MdMarkunreadMailbox />, bypassPageList: true },
          { path: "/floor-layout",        name: "Floor Layout",         icon: <TbLayoutGrid size={20} /> },
          { path: "/machines",            name: "Machines Master",      icon: <MdPrecisionManufacturing /> },
          { path: "/machines-group",      name: "Machine Group",        icon: <FaCogs /> },
          { path: "/machine-capabilities", name: "Work Center Capabilities", icon: <FaCogs />, bypassPageList: true },
          // Reference data
          { path: "/reason-registration", name: "Reasons",              icon: <TbChecklist /> },
          // Integrations & Settings
          { path: "/settings",            name: "General Settings",     icon: <TbSettings /> },
          { path: "/notification-center", name: "Notification Center",  icon: <RiNotificationBadgeLine /> },
          { path: "/erpreportschedule",   name: "Email Schedule",       icon: <BsCalendarCheckFill size={20} /> },
          { path: "/paperless-factory/settings", name: "Paperless Settings", icon: <TbSettings size={20} />, bypassPageList: true },
          ...(isAiAdmin
            ? [
                { path: "/ai-configuration", name: "Yantra Intelligence Config", icon: <MdManageAccounts />, bypassPageList: true },
                { path: "/interlock-settings", name: "Interlock Config",         icon: <MdLock />,           bypassPageList: true },
              ]
            : []),
          ...(user === "TENANT_ADMIN"
            ? [{ path: "/configuration", name: "Configuration", icon: <MdManageAccounts /> }]
            : []),
        ],
      },
    ];
    // Phase 2 v8 2026-06-26: Page Access is authoritative when configured.
    // - Admin/SuperAdmin/Tenant_Admin → see everything (no filter)
    // - User with configured pageList → strict filter (bypassPageList IGNORED)
    // - User with empty pageList (legacy/first-run) → fall back to bypassPageList behavior
    const pageListIsConfigured = Array.isArray(pageList) && pageList.length > 0;
    // Phase 2 v9 2026-06-26: only TB system-level admins bypass the page filter.
    // Customer-side "Admin" roles still respect their configured pageList.
    const isAdmin = (user === 'TENANT_ADMIN' || user === 'SYS_ADMIN');
    const isAllowed = (entry) => {
      if (isAdmin) return true;
      if (entry.alwaysShow) return true; // surgical: only entries explicitly flagged (e.g. TEEP)
      const key = (entry.path || '').replace(/^\//, '').replace(/\//g, '/');
      if (pageListIsConfigured) return pageList.includes(key) || pageList.includes(entry.path);
      // legacy fallback
      return entry.bypassPageList || pageList.includes(key);
    };

    return baseItems
      .map((item) => {
        if (item.children) {
          const allowedChildren = item.children.filter(isAllowed);
          return allowedChildren.length > 0 ? { ...item, children: allowedChildren } : null;
        }
        return isAllowed(item) ? item : null;
      })
      .filter(Boolean);
  }, [user, pageList, isAiAdmin]);


  useEffect(() => {
    console.log("Current active route:", location.pathname);
  }, [location]);

  const toggleFullscreen = useCallback(() => {
    if (isFullscreen) {
      if (isCssFallback.current) {
        isCssFallback.current = false;
        setIsFullscreen(false);
      } else if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    } else {
      const el = document.documentElement;
      if (el.requestFullscreen) {
        el.requestFullscreen().catch(() => {
          isCssFallback.current = true;
          setIsFullscreen(true);
        });
      } else if (el.webkitRequestFullscreen) {
        el.webkitRequestFullscreen();
      } else {
        isCssFallback.current = true;
        setIsFullscreen(true);
      }
    }
  }, [isFullscreen]);

  useEffect(() => {
    const handleFS = () => setIsFullscreen(
      !!document.fullscreenElement || !!document.webkitFullscreenElement
    );
    document.addEventListener('fullscreenchange', handleFS);
    document.addEventListener('webkitfullscreenchange', handleFS);
    return () => {
      document.removeEventListener('fullscreenchange', handleFS);
      document.removeEventListener('webkitfullscreenchange', handleFS);
    };
  }, []);

  useEffect(() => {
    const handleKey = (e) => {
      if ((e.key === 'f' || e.key === 'F') && !e.ctrlKey && !e.altKey && !e.metaKey) {
        const tag = document.activeElement?.tagName;
        if (tag !== 'INPUT' && tag !== 'TEXTAREA' && tag !== 'SELECT') {
          toggleFullscreen();
        }
      }
    };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [toggleFullscreen]);

  const handleLogout = () => {
    Swal.fire({
      title: 'Are you sure want  to logout?',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.isConfirmed) {
        stopTokenAutoRefresh();
        localStorage.clear();
        navigate('/');
      }
    });
  };

  const formattedUser = typeof user === 'string'
    ? user.toLowerCase().replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase())
    : '';

  const renderDropdown = (item, isOpenState, setIsOpenState) => (
    <div key={item.name}>
      <div
        className="link navlink"
        style={{
          textDecoration: 'none',
          color: '#000',
          display: 'flex',
          alignItems: 'center',
          gap: '14px',
          cursor: 'pointer',
          padding: '8px 12px'
        }}
        onClick={() => setIsOpenState(!isOpenState)}
      >
        <div className="icon">{item.icon}</div>
        {isOpen && (
          <div className="link_text" style={{ color: '#000' }}>
            {item.name} {isOpenState ? <GoChevronUp /> : <GoChevronDown />}
          </div>
        )}
      </div>

      {isOpenState && (
        <div style={{ marginLeft: isOpen ? '30px' : '0' }}>
          {item.children.map((child, idx) => (
            <NavLink
              to={child.path}
              key={idx}
              className={({ isActive }) =>
                isActive ? 'link navlink active' : 'link navlink'
              }
              onClick={handleMenuItemClick(child)}
              style={{
                textDecoration: 'none',
                color: '#000',
                display: 'flex',
                alignItems: 'center',
                gap: '14px',
                padding: '6px 12px'
              }}
            >
              <div className="icon">{child.icon}</div>
              {isOpen && (
                <div className="link_text" style={{ color: '#000' }}>
                  {child.name}
                </div>
              )}
            </NavLink>
          ))}
        </div>
      )}
    </div>
  );

  return (
    <>
      <Navbar className="navbar">
        <div className="navbarcontent">
          <Button variant="outline-info" onClick={toggle} style={{ textAlign: 'center', color: 'black' }}>
            <span className="menu-icon">&#9776;</span>
          </Button>
          <img className="Logo" src={logo} alt="Logo" />
          <span style={{ fontWeight: '500', fontSize: '20px' }}></span>
          <div className="rightsidecontents">
            <Tooltip title={isFullscreen ? 'Exit Fullscreen (F)' : 'Fullscreen (F)'}>
              <IconButton onClick={toggleFullscreen} size="small" style={{ color: 'black' }}>
                {isFullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
              </IconButton>
            </Tooltip>
            <NotificationBell />

            {/* Language switcher — placeholder until i18n is wired */}
            <div className="lang-switcher" onClick={() => setLangOpen(o => !o)} title={LANG_FULL[lang]}>
              <MdLanguage style={{ fontSize: 18 }} />
              <span className="lang-label">{LANG_LABELS[lang]}</span>
              {langOpen && (
                <div className="lang-menu" onClick={e => e.stopPropagation()}>
                  {Object.entries(LANG_FULL).map(([code, name]) => (
                    <button
                      key={code}
                      className={'lang-menu-item' + (code === lang ? ' active' : '')}
                      onClick={() => { setLang(code); setLangOpen(false); }}
                    >
                      {name}
                    </button>
                  ))}
                </div>
              )}
            </div>

            {/* Dark mode toggle */}
            <Tooltip title={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}>
              <label
                className="theme-toggle"
                onClick={() => setTheme(t => t === 'dark' ? 'light' : 'dark')}
                style={{ cursor: 'pointer' }}
              >
                {theme === 'dark' ? <MdLightMode /> : <MdDarkMode />}
              </label>
            </Tooltip>

            <span className="person" style={{
              backgroundColor: 'black',
              color: 'white',
              borderRadius: '50%',
              width: '36px',
              height: '36px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginRight: '15px',
            }}>
              <PersonOutlineIcon style={{ fontSize: '24px' }} />
            </span>
            <div>
              <h6>{username}</h6>
              <p>{mode || formattedUser}</p>
            </div>
            <Tooltip title="Log-out">
              <label className="circles-icon" onClick={handleLogout} style={{ cursor: 'pointer' }}>
                <MdPowerSettingsNew />
              </label>
            </Tooltip>
            {/* <IconButton onClick={handleClick} size="large">
              <MdMoreVert />
            </IconButton>

            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
              <MenuItem
                onClick={() => {
                  setShowChangePassword(true);
                  handleClose();
                }}
              >
                <Tooltip title="Change Password">
                  <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <MdLock style={{ fontSize: '20px' }} />
                    Change Password
                  </span>
                </Tooltip>
              </MenuItem>

              <MenuItem
                onClick={() => {
                  handleLogout();
                  handleClose();
                }}
              >
                <Tooltip title="Log out">
                  <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <MdPowerSettingsNew style={{ fontSize: '20px' }} />
                    Log out
                  </span>
                </Tooltip>
              </MenuItem>
            </Menu>

            {showChangePassword && (
              <ChangePasswordCard onClose={() => setShowChangePassword(false)} />
            )} */}
          </div>
        </div>
      </Navbar>

      <div className={`sidebar ${isOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
        <div className="top_section">
          {isOpen ? (
            <img className="Logo1" src={logo} alt="Yantra24x7" />
          ) : (
            <img className="LogoIcon" src="/yantra_icon.svg" alt="Y" />
          )}
        </div>
        {menuItem.map((item) => (
          item.children ? (
            // Velplast-style flat section — uppercase header + always-visible children
            <div key={item.name} className="sidebar-section">
              {isOpen && (
                <div className="sidebar-section-header">{item.name}</div>
              )}
              {item.children.map(child => (
                <NavLink
                  to={child.path}
                  key={child.path}
                  className={({ isActive }) =>
                    isActive ? 'link navlink section-item active' : 'link navlink section-item'
                  }
                  onClick={handleMenuItemClick(child)}
                  style={{
                    textDecoration: 'none',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    padding: '7px 10px'
                  }}
                  title={!isOpen ? child.name : undefined}
                >
                  <div className="icon">{child.icon}</div>
                  {isOpen && (
                    <div className="link_text">{child.name}</div>
                  )}
                </NavLink>
              ))}
            </div>
          ) : (
            <NavLink
              to={item.path}
              key={item.name}
              className={({ isActive }) =>
                isActive ? 'link navlink active' : 'link navlink'
              }
              onClick={handleMenuItemClick(item)}
              style={{
                textDecoration: 'none',
                color: '#000',
                display: 'flex',
                alignItems: 'center',
                gap: '14px',
                padding: '8px 12px'
              }}
            >
              <div className="icon">{item.icon}</div>
              {isOpen && (
                <div className="link_text" style={{ color: '#000' }}>
                  {item.name}
                </div>
              )}
            </NavLink>
          )
        ))}
      </div>

      <main
        className="main-content"
        style={{
          paddingLeft: isOpen
            ? '250px'
            : '85px',
          transition: 'padding-left 0.3s ease'
        }}
      >
        <Outlet />
      </main>
    </>
  );
}
